import React from 'react';
import '../graphStyles.scss';
import NoDataFound from "../../NoDataFound";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  BarController,
  LineController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  BarElement,
  LineController,
  BarController
);

export function ShopperOriginsGraph({ google, facebook, linkedin, instagram, direct, linktree, reddit, others, pinterest, hubspot, microsoft, afmc, weeks }) {

  const [legendClicked, setLegendClicked] = React.useState(false);

  function legendClickHandler(e, legendItem) {
    let datasetIndex = legendItem.datasetIndex;
    let ci = this.chart, metaSets = [];

    if (!legendClicked) {
      for (let i = 0; i < ci.data.datasets.length; i++) {
        metaSets.push(ci.getDatasetMeta(i));
      }
      metaSets.forEach(function (meta) {
        meta.hidden = meta.controller.index === datasetIndex ? false : true;
      });
      ci.update();
    } else {
      for (let i = 0; i < ci.data.datasets.length; i++) {
        metaSets.push(ci.getDatasetMeta(i));
      }
      metaSets.forEach(function (meta) {
        meta.hidden = meta.controller.index === datasetIndex ? false : false;
      });
      ci.update();
    }
    setLegendClicked(prev => !prev);
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        onClick: legendClickHandler,
        position: 'right',
        labels: {
          usePointStyle: true,
          useBorderRadius: true,
          padding: function () {
            if (window.innerWidth < 600) {
              return 6;
            } else if (window.innerWidth < 650) {
              return 7;
            } else if (window.innerWidth < 700) {
              return 8;
            } else if (window.innerWidth < 750) {
              return 9;
            } else if (window.innerWidth < 800) {
              return 10;
            } else if (window.innerWidth < 900) {
              return 10;
            } else if (window.innerWidth < 1100) {
              return 13;
            } else if (window.innerWidth < 1300) {
              return 16;
            } else {
              return 18;
            }
          },
          font: {
            size: function () {
              if (window.innerWidth < 600) {
                return 10;
              } else if (window.innerWidth < 700) {
                return 12;
              } else if (window.innerWidth < 800) {
                return 13;
              } else if (window.innerWidth < 900) {
                return 13.5;
              } else if (window.innerWidth < 1100) {
                return 14.5;
              } else if (window.innerWidth < 1300) {
                return 16;
              } else if (window.innerWidth < 1450) {
                return 17;
              } else if (window.innerWidth < 1600) {
                return 18;
              } else {
                return 19;
              }
            },
          },
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart22").style.cursor = 'pointer';
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart22").style.cursor = 'default';
        },
      },
    },
    scales: {
      x: {
        title: {
          text: "Week",
          display: true,
          font: {
            size: 13.5,
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          font: {
            margin: -5,
          },
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of shoppers',
          font: {
            size: 13.5,
          },
        },
      },
    },
  };

  const labels = weeks;

  const data = {
    labels,
    datasets: [
      {
        label: 'Google',
        type: 'line',
        data: google,
        borderColor: 'rgba(190, 70, 160, 0.6)',
        backgroundColor: 'rgba(230, 80, 140, 1)',
        hoverBackgroundColor: 'rgba(230, 80, 140, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Facebook',
        type: 'line',
        data: facebook,
        borderColor: 'rgba(32, 114, 255, 0.7)',
        backgroundColor: 'rgba(32, 114, 255, 1)',
        hoverBackgroundColor: 'rgba(32, 114, 255, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'LinkedIn',
        type: 'line',
        data: linkedin,
        borderColor: 'rgba(240, 200, 50, 0.7)',
        backgroundColor: 'rgba(240, 200, 50, 1)',
        hoverBackgroundColor: 'rgba(240, 200, 50, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Instagram',
        type: 'line',
        data: instagram,
        borderColor: 'rgba(250, 170, 200, 0.7)',
        backgroundColor: 'rgba(250, 170, 200, 1)',
        hoverBackgroundColor: 'rgba(250, 170, 200, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Direct',
        type: 'line',
        data: direct,
        borderColor: 'rgba(0, 240, 110, 0.6)',
        backgroundColor: 'rgba(0, 210, 0, 1)',
        hoverBackgroundColor: 'rgba(0, 210, 0, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Linktree',
        type: 'line',
        data: linktree,
        borderColor: 'rgba(200, 0, 0, 0.7)',
        backgroundColor: 'rgba(200, 0, 0, 1)',
        hoverBackgroundColor: 'rgba(200, 0, 0, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Reddit',
        type: 'line',
        data: reddit,
        borderColor: 'rgba(0, 230, 220, 0.7)',
        backgroundColor: 'rgba(0, 210, 200, 1)',
        hoverBackgroundColor: 'rgba(0, 210, 200, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Others',
        type: 'line',
        data: others,
        borderColor: 'rgba(100, 0, 180, 1)',
        backgroundColor: 'rgba(190, 0, 240, 0.7)',
        hoverBackgroundColor: 'rgba(190, 0, 240, 0.7)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Microsoft',
        type: 'line',
        data: microsoft,
        borderColor: 'rgba(0, 180, 50, 0.5)',
        backgroundColor: 'rgba(0, 120, 50, 1)',
        hoverBackgroundColor: 'rgba(0, 120, 50, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'HubSpot',
        type: 'line',
        data: hubspot,
        borderColor: 'rgba(100, 150, 0, 0.5)',
        backgroundColor: 'rgba(130, 180, 0, 1)',
        hoverBackgroundColor: 'rgba(130, 180, 0, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Pinterest',
        type: 'line',
        data: pinterest,
        borderColor: 'rgba(250, 140, 0, 0.5)',
        backgroundColor: 'rgba(230, 120, 0, 1)',
        hoverBackgroundColor: 'rgba(230, 120, 0, 1)',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
      {
        label: 'Affiliate Marketing (afmc)',
        type: 'line',
        data: afmc,
        borderColor: 'rgba(18, 28, 203, 0.5)',
        backgroundColor: '#244dc7',
        hoverBackgroundColor: '#244dc7',
        lineTension: 0.2,
        pointRadius: function () {
          return window.innerWidth < 600 ? 2 : 3;
        },
      },
    ],
  };

  return (
    <div className="graph">
      <div className="graph__title flex flex-col md:flex-row justify-between items-center">
        <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0">
          Where are the shoppers coming from?
        </h4>
      </div>
      <div className="relative w-full h-64 md:h-96">
        <Chart className="chart" id="chart22" options={options} data={data} />
      </div>
    </div>
  );
}
